import { Badge, Button, Dropdown, Empty } from 'antd';
import { useState } from 'react';
import NotificationIcon from '../../assets/icons/NotificationIcon';
import colors from '../../theme/colors';

const NotificationMenu = () => {
  //   const navigate = useNavigate();
  const [openDropdown, setOpenDropdown] = useState(false);

  return (
    <Dropdown
      trigger={['click']}
      placement="bottomRight"
      arrow={{ pointAtCenter: true }}
      open={openDropdown}
      onOpenChange={setOpenDropdown}
      popupRender={() => (
        <div className="w-72 bg-white shadow rounded-md">
          <div className="flex items-center justify-between gap-2 py-1.5 px-3 shadow-sm shadow-gray-100 sticky top-0">
            <span className="text-xs text-header font-medium">
              Notifications
            </span>
            {[]?.length ? (
              <div
                className="text-xs text-body font-medium hover:text-header"
                // to="/admin/notification"
                onClick={() => setOpenDropdown(false)}
              >
                View All
              </div>
            ) : null}
          </div>

          <div>
            <div className="h-56 overflow-y-auto notification">
              <Empty
                rootClassName="pt-10"
                styles={{ image: { height: 100 } }}
              />
            </div>
          </div>
        </div>
      )}
    >
      <Badge
        count={1}
        color={colors.error[500]}
        className="w-6 h-6 rounded-full flex justify-center items-center font-medium !leading-none relative left-[3px] top-[3px]"
      >
        <Button
          className="border-none shadow-none !text-theme-slate-300 hover:!text-theme-slate-300"
          icon={<NotificationIcon />}
          size="middle"
        />
      </Badge>
    </Dropdown>
  );
};
export default NotificationMenu;
